module.exports = __webpack_public_path__ + "lazerSlide.jpg?5057c37b1fecc250067799f1b09e0f6a";